import React from "react";
import "../css/StrengthMeter.css";

// Update log
// FB  7111   07/25/2023  DK  Added new component to display password strength

const StrengthMeter = (props: any) => {
    const Password = props.password;
    const initPasswordChecker = () => {
        let PasswordCheck = 0;
        let validateRegex = ["[A-Z]", "[a-z]", "[0-9]", "\\W"];
        if (Password != undefined && Password != "" && Password != null) {
            if (Password.length >= 8) {
                validateRegex.forEach((regex, i) => {
                    if (new RegExp(regex).test(Password)) {
                        PasswordCheck += 1;
                    }
                });
                if (PasswordCheck == 4) {
                    props.setIsCriteriaMet(true);
                }
            } else {
                props.setIsCriteriaMet(false);
            }
        } else {
            props.setIsCriteriaMet(false);
        }
        switch (PasswordCheck) {
            case 0:
                return {
                    strength: 0,
                    val: "",
                };
            case 1:
                return {
                    strength: 1,
                    val: "Weak",
                };
            case 2:
                return {
                    strength: 2,
                    val: "Fair",
                };
            case 3:
                return {
                    strength: 3,
                    val: "Good",
                };
            case 4:
                return {
                    strength: 4,
                    val: "Strong",
                };
            default:
                return null;
        }
    };

    return (
        <>
            <div className="wrapper" style={props.width ? { width: "400px" } : {}}>
                <progress
                    className={`pwd-checker-bar strength-${initPasswordChecker()?.val}`}
                    value={initPasswordChecker()?.strength}
                    max="4"
                /> <strong>{initPasswordChecker()?.val} </strong>
            </div>
        </>
    );
};
export default StrengthMeter;